<template>
  <a-modal destroyOnClose={true} v-model="visible" title="SMS Delivery Report" onOk="handleOk" :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 1080" style="top: 20px">

    <a-spin :spinning="spinning">
      <div class="row">
        <div class="col-lg-12">
          <!-- Chart Area -->
          <vc-donut has-legend :total="100" :start-angle="0" :sections="sections">Total SMS (<b>{{this.overallReport.total_count}}</b>)</vc-donut>
        </div>
      </div>
      <a-table
        :columns="columns"
        :row-key="record => record.id"
        :data-source="individualNotifications"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <!--      <template slot="name" slot-scope="name"> {{ name.first }} {{ name.last }} </template>-->
        <template slot="student_code" slot-scope="student_code">
              <div>
                <div class="font-weight-bold">
                  <span class="text-wrap">{{student_code}}</span>
                </div>
              </div>
            </template>
            <template slot="first_name" slot-scope="first_name">
              <div>
                <span class="text-wrap">{{first_name}}</span>
              </div>
            </template>
            <template slot="last_name" slot-scope="last_name">
              <div>
                <span class="text-wrap">{{last_name}}</span>
              </div>
            </template>
        <template slot="phone" slot-scope="phone">
          <div>
            <span class="text-wrap">{{phone}}</span>
          </div>
        </template>
        <template slot="status" slot-scope="status">
            <div>
              <a-tag
                :color="status === 'sent' ? 'blue' :
                status === 'delivered' ? 'green' :
                status === 'read' ? 'purple' :
                status === 'failed' ? 'red' :
                status === 'rejected' ? 'volcano' : 'gold'">{{status.toUpperCase()}}</a-tag>
            </div>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>
<script>
// import axios from 'axios'
import { mapState } from 'vuex'

const queryData = ($http, schoolNotificationId, params) => {
  return $http.get('/api/notifications/smsdeliverystatus/' + schoolNotificationId, { params: params })
  // return axios.get('https://randomuser.me/api', { params: params })
}
/* const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: true,
    width: '20%',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    filters: [
      { text: 'Male', value: 'male' },
      { text: 'Female', value: 'female' },
    ],
    width: '20%',
  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
] */

const columns = [
  {
    title: 'Code/ID',
    className: 'text-left',
    width: 100,
    dataIndex: 'code',
    scopedSlots: { customRender: 'code' },
    sorter: true,
  },
  {
    title: 'Type',
    className: 'text-left',
    width: 100,
    dataIndex: 'receiver_type',
    scopedSlots: { customRender: 'receiver_type' },
    filters: [
      { text: 'Student', value: 'STUDENT' },
      { text: 'Staff', value: 'STAFF' },
    ],
  },
  {
    title: 'First Name',
    className: 'text-left',
    width: 250,
    dataIndex: 'first_name',
    scopedSlots: { customRender: 'first_name' },
    sorter: true,
  },
  {
    title: 'Last Name',
    className: 'text-left',
    width: 250,
    dataIndex: 'last_name',
    scopedSlots: { customRender: 'last_name' },
    sorter: true,
  },
  {
    title: 'Phone',
    className: 'text-left',
    width: 150,
    dataIndex: 'phone',
    scopedSlots: { customRender: 'phone' },
  },
  {
    title: 'Status',
    className: 'text-left text-gray-6',
    width: 100,
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    filters: [
      { text: 'Sent', value: 'sent' },
      { text: 'Delivered', value: 'delivered' },
      { text: 'Failed', value: 'failed' },
      { text: 'Rejected', value: 'rejected' },
      { text: 'NDNC', value: 'ndnc' },
      { text: 'Blocked', value: 'blocked' },
      { text: 'Undefined', value: 'undefined' },
    ],
  },
]

export default {
  name: 'ReportSection',
  data() {
    return {
      data: [],
      columns,
      loading: false,
      visible: false,
      spinning: false,
      schoolNotificationId: null,
      individualNotifications: null,
      overallReport: null,
      pagination: { pageSize: 10 },
      sections: [
        { label: 'Sent', value: 0 },
        { label: 'Delivered', value: 0 },
        { label: 'Failed', value: 0 },
        { label: 'Rejected', value: 0 },
        { label: 'NDNC', value: 0 },
        { label: 'Blocked', value: 0 },
        { label: 'Undefined', value: 0 },
      ],
    }
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  mounted: function () {
    this.$eventBus.$on('openSmsDeliveryReportModal', this.showModal)
  },
  /* mounted() {
    this.fetch()
  }, */
  methods: {
    showModal: function(schoolNotificationId) {
      this.fetch(schoolNotificationId, {
        limit: 30,
      })
      this.visible = true
      this.spinning = true
      this.loading = true
      /* this.schoolNotificationId = schoolNotificationId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/notifications/smsdeliverystatus/' + schoolNotificationId).then(({ data }) => {
        this.individualNotifications = data.data.individual_notifications.data
        // this.overallReport = data.data.overall
        console.log(this.individualNotifications)
        this.spinning = false
        this.loading = false
      }) */
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(pagination)
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.fetch(this.schoolNotificationId, {
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      })
    },
    fetch(schoolNotificationId, params = {}) {
      this.loading = true
      queryData(this.$http, schoolNotificationId, {
        ...params,
      }).then(({ data }) => {
        const pagination = { ...this.pagination }
        this.individualNotifications = data.data.individual_notifications.data
        this.overallReport = data.data.overall
        this.fillChartValue(this.overallReport)
        pagination.total = data.data.individual_notifications.total
        pagination.pagesize = data.data.individual_notifications.per_page
        pagination.current = data.data.individual_notifications.current_page
        this.schoolNotificationId = data.data.overall.school_notification_id
        this.loading = false
        this.spinning = false
        this.pagination = pagination
      })
    },
    fillChartValue(overallReport) {
      console.log(overallReport)
      const totalCount = overallReport.total_count

      let labelSent = `Sent (${overallReport.sent_count})`
      let labelDelivered = `Delivered (${overallReport.delivered_count})`
      let labelFailed = `Failed (${overallReport.failed_count})`
      let labelRejected = `Rejected (${overallReport.rejected_count})`
      let labelNDNC = `NDNC (${overallReport.ndnc_count})`
      let labelBlocked = `Blocked (${overallReport.blocked_count})`
      let labelUndefined = `Undefined (${overallReport.undefined_count})`

      this.sections = [
        { label: labelSent, color: '#36A2EB', value: (overallReport.sent_count * 100) / totalCount },
        { label: labelDelivered, color: '#78D24B', value: (overallReport.delivered_count * 100) / totalCount },
        { label: labelFailed, color: '#FF6384', value: (overallReport.failed_count * 100) / totalCount },
        { label: labelRejected, color: 'red', value: (overallReport.rejected_count * 100) / totalCount },
        { label: labelNDNC, color: 'purple', value: (overallReport.ndnc_count * 100) / totalCount },
        { label: labelBlocked, color: 'black', value: (overallReport.blocked_count * 100) / totalCount },
        { label: labelUndefined, color: 'grey', value: (overallReport.undefined_count * 100) / totalCount },
      ]
    },
  },
}
</script>
